export const IS_SENDING_EMAIL = "IS_SENDING_EMAIL";
export const EMAIL_SENT_SUCCESS = "EMAIL_SENT_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
